<template>
  <div>
    <div class="content_right3">
      <div class="Company_box">
        <p class="Company_text">资讯中心</p>
        <div class="arrow-right">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }"
              >你现在所在的位置</el-breadcrumb-item
            >
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>资讯中心</el-breadcrumb-item>
            <!-- <el-breadcrumb-item>新闻资讯</el-breadcrumb-item> -->
          </el-breadcrumb>
        </div>
      </div>
   
      <div class="news_box1">
        <div class="InformationNews">
          <img src="../../assets/img/xinw04.jpg" alt />
        </div>
        <div class="newsContent">
          <!-- <div class="first"><span>公司新闻</span><span class="genduo" @click="gnduo(2)">更多</span></div> -->
          <div class="first"><span>公司新闻</span><span class="genduo" @click="gnduo(2)">更多</span></div>
          <div
            style="display: flex; justify-content: space-between"
            v-for="(item, index) in list"
            :key="index"
            @click="Companynews(item.id,item.bid,2)"
          >
            <p class="first_text">{{ item.title }}</p>
            <div style="margin-top: 2%">{{item.addTime}}</div>
          </div>
        </div>
      </div>
      <div
        style="
          display: flex;
          justify-content: space-between;
          margin-bottom: 4%;
          margin-top: 5%;
        "
      >
        <div class="newsContent">
          <!-- <div class="first"><span>行业新闻</span><span class="genduo" @click="gnduo(3)">更多</span></div> -->
          <div class="first"><span>行业新闻</span><span class="genduo" @click="gnduo(3)">更多</span></div>
          <div
            style="display: flex; justify-content: space-between"
            v-for="(item, index) in list2"
            :key="index"
            @click="Companynews(item.id,item.bid,3)"
          >
            <p class="first_text">{{ item.title }}</p>
            <div style="margin-top: 2%">{{item.addTime}}</div>
          </div>
        </div>
        <div class="newsContent">
          <div class="first"><span>媒体聚焦</span><span class="genduo" @click="gnduo(4)">更多</span></div>
          <div
            style="display: flex; justify-content: space-between"
            v-for="(item, index) in list3"
            :key="index"
            @click="Companynews(item.id,item.bid,4)"
          >
            <p class="first_text">{{ item.title }}</p>
            <div style="margin-top: 2%">{{item.addTime}}</div>
          </div>
        </div>
      </div>
      
    </div>
  </div>
</template>
<script>
import pagination from "../../components/haed/pagination";
import qs from "qs";
export default {
  components: {
    pagination,
  },
  data() {
    return {
      tabPosition: "left",
      list: [],
      list2:[],
      list3:[],
      listQuery: {
        bsId: "",
        pageNum: 1,
        pageSize: 3,
      },
      total: 9,
      Name:"2",
      qwer:""
    };
  },
  created() {
    this.news();
    this.news2()
    this.news3()
    if(this.$route.query.qe){
        this.Name=this.$route.query.qe
    }
  },
  methods: {
    getShowLists() {
      this.news();
    },
    gnduo(go){
      // this.$router.push({path:"/listTitle?name="+go})
      // this.$router.push({path:"/index?name="+go})
      // this.Name=go
      this.$emit('func',go)

     
    },
    Companynews(id,bid,name) {
      this.$router.push({ path: "/Companynews?id=" + id+ "&bid="+bid+"&qe="+name});
    },
    news: function () {
      this.$axios({
        method: "post",
        url: "/index.php/news/newslist",
        data: qs.stringify({
          id: 12,
          pageNum: this.listQuery.pageNum,
          pageSize: 9,
        }),
      })
        .then((res) => {
          this.list = res.data.data;
          this.total = res.data.datanum;
        })
        .catch((res) => {
        });
    },
     news2: function () {
      this.$axios({
        method: "post",
        url: "/index.php/news/newslist",
        data: qs.stringify({
          id: 13,
          pageNum: this.listQuery.pageNum,
          pageSize: 9,
        }),
      })
        .then((res) => {
          this.list2 = res.data.data;
          // this.total = res.data.datanum;
        })
        .catch((res) => {
        });
    },
     news3: function () {
      this.$axios({
        method: "post",
        url: "/index.php/news/newslist",
        data: qs.stringify({
          id: 14,
          pageNum: this.listQuery.pageNum,
          pageSize: 9,
        }),
      })
        .then((res) => {
          this.list3 = res.data.data;
          // this.total = res.data.datanum;
        })
        .catch((res) => {
        });
    },
  },
};
</script>
<style scoped>
.el-breadcrumb{
  font-size: 0.9vw !important;
}
.genduo{
  cursor:pointer
}
.personne2 {
  height: 1.9vw;
  color: #0b449d;
  font-size: 1.5vw;
  margin: 0 auto;
  /* margin-left: 30%; */
}
.content_right3 {
  /* width: 98%; */
  margin-left: 40px;
}

.enterprise_name {
  font-size: 1.5vw;
  color: #0c47a1;
  text-align: center;
  margin-top: 1vw;
}
.enterprise_box {
  width: 100%;
  height: 17vw;
  margin-top: 1vw;
  display: flex;
  justify-content: space-between;
}
.enterprise_img {
  width: 15vw;
  height: 15vw;
}
.enterprise_img img {
  width: 100%;
  height: 100%;
}
.enterprise_text {
  width: 80%;
  height: 100%;
  font-size: 1.5vw;
}
.Organization_box {
  width: 80%;
  height: 17vw;
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
}
.InformationNews {
  width: 350px;
  height: 250px;
}
.InformationNews img {
  width: 100%;
  height: 100%;
}
/* .Organization{
  width: 80%;
  height: 10vw;
  background: darkgreen;
} */
.Organization_img {
  width: 35vw;
  height: 17vw;
  background: url("../../assets/img/gss07.jpg") no-repeat;
  background-size: 100%;
  text-align: center;
  line-height: 18vw;
  font-size: 2vw;
  color: #fff;
}
.Company_box {
  width: 100%;
  height: 2vw;
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
  border-bottom: 1px solid #dedede;
}
.Company_text {
  font-weight: bold;
  font-size: 32px;
  color: #0c47a1;
  text-align: center;
  line-height: 2vw;
  margin-left: 10px;
  margin-top: -0.5vw;
}
.arrow-right {
  text-align: center;
  margin-top: 0.2vw;
}

.english {
  margin: 0 auto;
  font-size: 1vw;
  text-align: center;
  color: #0b449d;
}
.ys {
  color: #ccc;
}
.Piece {
  width: 10%;
  height: 0.1vw;
  background-color: #0b449d;
  margin: 0 auto;
  margin-top: 10px;
}
.news_box1 {
  width: 100%;
  /* height: 21vw; */
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
  /* margin-left: 15%; */
}
.news_img2 {
  width: 40%;
  height: 25vw;
  background: darkgreen;
}
.newsContent {
  width:46%;
  height: 252px;
  font-size:16px;
  color: #0b449d;
  overflow: hidden;
}
.first {
  display: flex;
  font-size: 20px;
  color: #76b5ff;
  justify-content: space-between;
}
.first_text {
  margin-top: 10px;
  width: 70%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.first_text:hover {
  cursor: pointer;
  color: red;
}
.first_text2 {
  margin-left: 10vw;
  margin-top: 10px;
}
.Pagination_box {
  display: flex;
  width: 40%;
  height: 2vw;
  margin: 0 auto;
  margin-top: 2vw;
}
.Organization_box1 {
  width: 93%;
  display: flex;
  height: 17vw;
  justify-content: space-between;
  margin-top: 20px;
  margin-left: 10px;
  /* background-color: chocolate; */
}
@media screen and (max-width: 768px) {
  .content_right3 {
    margin-left: 0 !important;
  }
  .Company_text {
    margin-top: 1.5%;
  }
  .ys {
    display: none;
  }
  .english {
    margin-top: 10px;
  }
  .first_text {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .news_box1 {
    width: 100%;
    margin-left: 0;
  }
  .newsContent {
    height: 40 !important;
  }
  .first_text {
    margin-top: 0;
  }
  .el-pagination {
    display: none;
  }
}
</style>
<style>
.el-pagination {
  width: 40%;
  margin: 0 auto;
}
.el-breadcrumb {
  font-size: 0.9vw;
}
</style>


// WEBPACK FOOTER //
// src/components/haed/news.vue